import { IAction } from '../../../__core/Interfaces/IAction';
import COURSE_ACTIONS from './ActionTypes';
import { CoursesListResponse } from '../Types/CoursesListResponse';
import { ProductsListResponse } from '../Types/ProductsListResponse';

export const getCoursesListSuccess = (
  courseInstances: CoursesListResponse
): IAction<CoursesListResponse> => ({
  type: COURSE_ACTIONS.FETCH_COURSES_LIST,
  payload: courseInstances,
});

export const getProductsListSuccess = (
  products: ProductsListResponse
): IAction<ProductsListResponse> => ({
  type: COURSE_ACTIONS.FETCH_DIRECT_ACCESS_LIST,
  payload: products,
});
